import { EXPORT_TYPES } from 'dynamo-daos/build/models/jobs/exportRecord';

import apiRequest from './apiRequest';

export interface ExportCostRequest {
  format: EXPORT_TYPES;
  objectID: string;
  software?: string;
}

export interface ExportCostResponse {
  isFreeExport: boolean;
  costInSpins: number;
}

export default async function getExportCost(
  projectID: string,
  params: ExportCostRequest,
) {
  // Build query string from params
  const queryParams = new URLSearchParams({
    format: params.format,
    objectID: params.objectID,
  });

  if (params.software) {
    queryParams.append('software', params.software);
  }

  const { data, error } = await apiRequest<ExportCostResponse>(
    'mogen-orchestration',
    `/v2/projects/${projectID}/export/cost?${queryParams.toString()}`,
  );

  return {
    data,
    error,
  };
}
